import React from 'react';
import { Text } from '@components/Text/Text.component';
import { ApiStatusCode } from '@utils/api.utils';
import { defaultNamespaces } from '@utils/strings';
import { PlcNextPage } from 'features/business/app.types';

import './Error.scss';

type ErrorProps = {
  errorCode?: number;
};
const Error: PlcNextPage<ErrorProps> = ({ errorCode }) => {
  const getErrorLabel = (code: number | undefined) => {
    switch (code) {
      case ApiStatusCode.notFound:
        return 'common.error.404';
      case ApiStatusCode.unauthorized:
        return 'common.error.401';
      default:
        return 'common.error.generic';
    }
  };

  return (
    <main className="error-page">
      <div className="container">
        {errorCode && (
          <Text tag="span" variant="h1">
            {errorCode}
          </Text>
        )}
        <Text
          // i18nKey={errorCode === ApiStatusCode.notFound ? 'common.error.404' : 'common.error.generic'}
          i18nKey={getErrorLabel(errorCode)}
          tag="h1"
          variant="h3"
        />
      </div>
    </main>
  );
};

Error.getInitialProps = ({ res, err }) => {
  // eslint-disable-next-line no-nested-ternary
  const statusCode = res ? res.statusCode : err ? err.statusCode : ApiStatusCode.notFound;
  return { errorCode: statusCode, namespacesRequired: defaultNamespaces };
};

export default Error;
